<template>
  <div class="screen-blocks">
    <div class="header-setting">
      <div class="header-setting__label">Block列表</div>
    </div>
    <div class="body-setting">
      <div class="body-setting__content">
        <image-link-editor
          v-model="$$FormData.blocks"
          :limit="999"
          show-image
          show-sub-title
          add-text="添加Block"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenBlocksSettings'
}
</script>

<style scoped lang="scss">
.screen-blocks {
  .body-setting {
    overflow: hidden;
  }
  .body-setting__content {
    background-color: #ffffff;
    padding: 12px;
  }
}
</style>